import Done from 'common/Done';

function ChangePassSuccess() {
  return <Done message="Done!" detail="Please check your inbox for reset password link." />;
}

export default ChangePassSuccess;
